import { useQuery } from "@tanstack/react-query";

import { referralService } from "@/services/referralService";

export const REFERRAL_QUERY_KEYS = {
  ALL: ["referral"] as const,
};

export function useReferral() {
  return useQuery({
    queryKey: REFERRAL_QUERY_KEYS.ALL,
    queryFn: () => referralService.getReferralInfo(),
    retry: false,
  });
}
